import React from 'react';
import { ReactModel } from '../../react-model/react-model';
import { useOnModelChange } from '../hooks/use-on-model-change';

type KS<T> = Extract<keyof T, string>;
/** A generic element that can update with the model */
export interface HElementProps<T> extends React.HTMLAttributes<HTMLElement> {
	model: ReactModel<T>;
	/** use div, strong, center, span ... */
	tag: string; //  React.DetailedHTMLProps<any, any>;
	/** if specified, use the value as children */
	field_to_prop?: { [P in keyof T]?: KS<React.HTMLAttributes<HTMLElement>> };
	/** Set the component properties when then model changes */
	onModelChange?: (state: T) => void| React.HTMLAttributes<HTMLElement>;
	/** The word "ref" is reserved. We have to use ref2 */
	ref2?: { current: HTMLElement | null };
	//onChange?:(e:React.ChangeEvent<HTMLInputElement>)=>void,
}

export function HElement<T>({ model, field_to_prop, ref2, onModelChange, tag, ...props }: HElementProps<T>) {
	if (field_to_prop) {
		const { state } = model.useModel();
		//update props
		for (const [field, prop] of Object.entries(field_to_prop)) {
			let v = state[field as keyof typeof state] as any;
			//the JSX element is an object, so we ignore 'children'
			if (prop !== 'children' && v && typeof v === 'object') {
				v = JSON.stringify(v).replaceAll('"', '');
			}
			props[prop as keyof typeof props] = v;
		}
	}

	useOnModelChange(model, onModelChange, props);

	try {
		return React.createElement(tag || 'div', props, props.children);
	} catch (e) {
		console.error(e);
		return <span style={{ color: 'red' }}>Fail to create "{tag}"</span>;
	}
}
